<template>
  <div class="dashboard-container">
    <router-link to="/" class="btn">Go to Home</router-link>
    <h2>Dashboard</h2>
    <div v-if="userName">
      <p class="welcome-message">Welcome to your dashboard, {{ userName }}!</p>
      <div class="link-buttons">
        <!-- link to coffee-tracker page -->
        <router-link to="/coffee-tracker" class="btn"><span class="emoji">&#9749;</span>Coffee Tracker</router-link>
        <!-- link to sex-tracker page -->
        <router-link to="/sex-tracker" class="btn"><span class="emoji">&#127814;</span>X Tracker</router-link>
        <!-- Link to weight-tracker -->
        <router-link to="/weight-tracker" class="btn"><span class="emoji">&#127919;</span>Weight Tracker</router-link>
        <!-- Link to toilet-tracker -->
        <router-link to="/toilet-tracker" class="btn"><span class="emoji">&#128169;</span>Toilet Tracker</router-link>
        <!-- Link to my-data -->
        <router-link to="/my-data" class="btn"><span class="emoji">&#128202;</span>My Data</router-link>
      </div>
    </div>
    <p v-else>Loading...</p>
  </div>
</template>

<script>
export default {
  name: "UserDashboard",
  data() {
    return {
      userName: "", // this will store the user's name/email
    };
  },
  mounted() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      // Get the token from the URL query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      // If the token exists in the URL, store it in localStorage
      if (token) {
        localStorage.setItem("token", token);
        // Clean up the URL by removing the token parameter after storing it
        this.$router.replace({ path: this.$route.path });
      }

      // Proceed to fetch user info with the token
      this.getUserInfo();
    },

    getUserInfo() {
      const token = localStorage.getItem("token");

      if (!token) {
        // If no token is found, redirect back to the homepage
        this.$router.push("/");
        return;
      }
      // process.env.VUE_APP_API_URL
      // Make a request to your backend API (protected route) with the JWT token
      fetch(`${process.env.VUE_APP_API_URL}/api/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Set the token in the Authorization header
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch user data");
          }
          return response.json();
        })
        .then((data) => {
          if (data.user) {
            // Populate the userName with the user's email or any other info
            this.userName = data.user.email;
          } else {
            this.$router.push("/");
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          this.$router.push("/");
        });
    },
  },
};
</script>

<style scoped>
/* General container styling for mobile */
.dashboard-container {
  padding: 16px;
  text-align: left; /* Ensures everything is left-aligned */
}

h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 16px;
}

.welcome-message {
  font-size: 18px;
  margin-bottom: 20px;
  color: #555;
}

/* Link buttons styling */
.link-buttons {
  display: flex;
  flex-direction: column; /* Stacks buttons vertically */
  gap: 10px; /* Space between buttons */
}

.btn {
  width: 180px;
  justify-content: center;
  padding: 10px 15px;
  background-color: black;
  color: white;
  border-radius: 5px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #0056b3;
}
.emoji {
  margin-right: 5px;
  font-size: 15px;
}
</style>
